import type { TextProps } from '@chakra-ui/react';
import { Text } from '@chakra-ui/react';
import { useLocalStorage, UserLocale } from 'hooks/userPreferences';
import { isTaxIncludedCountry } from 'utils/localisation/isTaxIncludedCountry';

interface PriceVATMessageProps extends TextProps {
  beforeText?: string;
}

export function PriceVATMessage({
  beforeText,
  ...props
}: PriceVATMessageProps) {
  const {
    value: { countryCode },
    isLoading: isLocaleLoading,
  } = useLocalStorage(UserLocale);

  if (isLocaleLoading) {
    return null;
  }

  const isTaxIncluded = isTaxIncludedCountry(countryCode);

  return (
    <Text {...props}>
      {beforeText} {beforeText && ' '}
      {isTaxIncluded ? ' incl. VAT' : 'excl. VAT'}
    </Text>
  );
}
